define([], function () {
    'use strict';
    return {
        customMeasure: (id, measureMap, nodesMap) => {
            const node = nodesMap[id];
            if (!node || !node.firstElementChild) {
                return;
            }
            const firstChild = node.firstElementChild;
            measureMap.height[id] = firstChild.offsetHeight;
        }
    };
});
